
<template>   
    <router-view></router-view>  
</template>
 
<script lang="ts">
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "RelatorioIndex",
        components: {    },  
    }) 
    export default class RelatorioIndex extends Vue {
         
    }
  
</script>
  